import React, { PropTypes } from 'react';
import { Link, IndexLink } from 'react-router';

import 'styles/footer.scss';

const Footer = (props) => {
    return (
        <footer className="section footer">
          <div className="container">
            <div className="footer-copy">
              &copy; {new Date().getFullYear()}
            </div>
            <div className="footer-links">
              <ul>
                <li>
                  email: <a href="mailto:kiandrahebert@gmail.com">kiandrahebert@gmail.com</a>
                </li>
                <li>
                  call: <a href="tel:619-357-6579">(619) 357-6579</a>
                </li>
              </ul>
            </div>
          </div>
        </footer>
    );
};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/